import mod from "-!../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./navigation-button.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./navigation-button.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/button/africa/navigation-button.vue?vue&type=script&lang=js
// module id = 3mzq
// module chunks = 37